import { render, staticRenderFns } from "./ConfirmDeleteAllDictionary.vue?vue&type=template&id=28f1829c&scoped=true&"
import script from "./ConfirmDeleteAllDictionary.vue?vue&type=script&lang=js&"
export * from "./ConfirmDeleteAllDictionary.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmDeleteAllDictionary.vue?vue&type=style&index=0&id=28f1829c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f1829c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VDialog,
  VIcon,
})
